import React from 'react';
import Footer from '../components/Footer';
import { Toaster } from 'sonner';
import { Badge } from '../components/ui/badge';
import { buildDashboardUrl } from '../lib/subdomain';
import ToolSeoBlock from './components/ToolSeoBlock';

// Shared chrome for every individual tool page.
// Children render the tool's own UI (uploader, controls, result panel, etc.).
function ToolLayout({ tool, children }) {
  const dashboardUrl = buildDashboardUrl();
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Toaster position="top-right" richColors />

      <header className="sticky top-0 z-20 backdrop-blur bg-background/80 border-b border-border">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <a href={dashboardUrl} className="flex items-center gap-2">
            <img src="/logo.webp" alt="TinyPDFs" className="h-8" width="60" height="32" decoding="async" />
            <span className="text-sm font-semibold tracking-tight">
              TinyPDFs <span className="text-orange-500">Tools</span>
            </span>
          </a>
          <a
            href={dashboardUrl}
            className="text-sm text-muted-foreground hover:text-orange-500"
          >
            All tools
          </a>
        </div>
      </header>

      <section className="px-4 py-10 border-b border-border">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-5xl mb-3" aria-hidden>{tool.icon}</div>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">
            {tool.name}
          </h1>
          <p className="mt-3 text-muted-foreground">{tool.short}</p>
          <div className="mt-4 flex items-center justify-center gap-2">
            <Badge className="bg-green-500/10 text-green-600 border border-green-500/20 text-[10px] uppercase tracking-wide">
              Free
            </Badge>
            {tool.status === 'coming_soon' ? (
              <Badge variant="secondary" className="text-[10px] uppercase tracking-wide">
                Coming soon
              </Badge>
            ) : null}
          </div>
        </div>
      </section>

      <main className="flex-1 px-4 py-10">
        <div className="max-w-4xl mx-auto">
          {children}
          <ToolSeoBlock tool={tool} />
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ToolLayout;
